module.exports = __webpack_public_path__ + "img/Weapon_291.8fce618f.png";